import { Box } from '@mui/material';
import { useState, useEffect } from 'react';
import { useFormikContext } from 'formik';
import FormikAutocomplete, { OptionType } from '@/common/presentation/components/forms/fields/FormikAutocomplete';
import { RaptorJobFormValues } from '../../../../RaptorJobValidationSchema';
import { useListSalesRegionsAutocomplete } from '@/raptorjob/application/adapters/useListSalesRegionsAutocomplete';
import { useListSalesAgentsAutocomplete } from '@/raptorjob/application/adapters/useListSalesAgentsAutocomplete';
import tid from '@/common/application/utils/tid';

export function SalesSection() {
  const { values, setFieldValue } = useFormikContext<RaptorJobFormValues>();
  const [salesRegionSearchTerm, setSalesRegionSearchTerm] = useState('');
  const {
    options: salesRegionOptions,
    loading: salesRegionLoading,
    filterOptions: salesRegionFilterOptions
  } = useListSalesRegionsAutocomplete(salesRegionSearchTerm);

  const [salesAgentSearchTerm, setSalesAgentSearchTerm] = useState('');
  const {
    options: salesAgentOptions,
    loading: salesAgentLoading,
    filterOptions: salesAgentFilterOptions,
    defaultSalesAgentOption
  } = useListSalesAgentsAutocomplete(salesAgentSearchTerm, 1000);

  // Set default sales agent when creating new job and default option is available
  // SalesSection is only used for creating new RaptorJobs, so isNew is always true
  useEffect(() => {
    if (defaultSalesAgentOption && typeof defaultSalesAgentOption.value === 'number' && !values.salesAgentId && !salesAgentLoading) {
      setFieldValue('salesAgentId', defaultSalesAgentOption.value);
    }
  }, [defaultSalesAgentOption, values.salesAgentId, salesAgentLoading, setFieldValue]);

  return (
    <>
      <Box
        sx={{
          mt: 1,
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr' },
          gap: '12px',
          width: '100%'
        }}
      >
        <FormikAutocomplete<OptionType, RaptorJobFormValues>
          id="salesAgentId"
          label="Sales Agent"
          options={salesAgentOptions}
          optionsloading={salesAgentLoading}
          filterOptions={salesAgentFilterOptions}
          onInputChange={(_, value) => setSalesAgentSearchTerm(value)}
          getOptionLabel={(option: OptionType) => option.label}
          isOptionEqualToValue={(option: OptionType, value: OptionType) => option.value === value.value}
          sx={{ width: '100%' }}
          {...tid('jobs:create:sales-agent-autocomplete')}
        />
      </Box>
      <Box
        sx={{
          mt: 1,
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr' },
          gap: '12px',
          width: '100%'
        }}
      >
        <FormikAutocomplete<OptionType, RaptorJobFormValues>
          id="salesRegionId"
          label="Sales Region"
          options={salesRegionOptions}
          optionsloading={salesRegionLoading}
          filterOptions={salesRegionFilterOptions}
          onInputChange={(_, value) => setSalesRegionSearchTerm(value)}
          getOptionLabel={(option: OptionType) => option.label}
          isOptionEqualToValue={(option: OptionType, value: OptionType) => option.value === value.value}
          sx={{ width: '100%' }}
          {...tid('jobs:create:sales-region-autocomplete')}
        />
      </Box>
    </>
  );
}
